import React from 'react';

import _ from 'lodash';

import { makeStyles } from '@mui/styles';
import { SearchField } from '../../../../inputs/SearchField';
import { useQueryParams } from '../../../../providers/QueryParamsProvider';
import { useURLSearchHandler } from './useURLSearchHandler';
import { TOOLBAR_CONTROL_HEIGHT } from '../../../../inputs/toolbarControlHeight';

type Props = Omit<React.ComponentProps<typeof SearchField>, 'onChange'>;

export const TableSearch = (props: Props) => {
  const { query } = useQueryParams();
  const classes = useStyles();

  const handleSearch = useURLSearchHandler();

  return (
    <SearchField
      defaultValue={_.get(query, 'search')}
      onChange={handleSearch}
      placeholder="Search"
      delay={500}
      {...props}
      classes={classes}
    />
  );
};

const useStyles = makeStyles(({ config, palette }) => ({
  root: {
    backgroundColor: palette.background.default,
    border: `1px solid ${palette.notification.containerBorder}`,
    marginRight: '0rem',
    // Shared with the date-range picker it sits beside in most toolbars.
    height: TOOLBAR_CONTROL_HEIGHT,
    '& input': {
      height: '2rem',
      padding: '0.25rem',
      fontSize: '0.9rem',
    },
  },
  focused: {
    border: `1px solid ${config.colors.darkBlue}`,
  },
}));
